const AuthReducer = (state, action) => {
    switch(action.type){
        case 'SET_LOADING':
            return {
              ...state,
              isLoading: action.payload,
            };
        case "LOGIN_START":
            return { 
                ...state, 
                error: false,
                isLoading: true 
            };
        case "LOGIN_SUCCESS":
            return{
                ...state,
                user: action.payload,
                error: false,
                isLoading: false
            };
        case "LOGIN_FAILURE":
            return{
                ...state,
                user: null,
                error: action.payload,
                isLoading: false,
            };
        case "SET_SOCKET":
            return{
                ...state,
                socket_context: action.payload,
            };
        case "REMOVE_SOCKET":   
            return{
                ...state,
                socket_context: null,
            };
        case "UPDATE_USER":
            return{
                ...state, user: { ...action.payload }
            };
        case "LOGOUT":
            return{
                user: null,
                isLoading: false,
                error: false,
            };
        case 'UPDATE_BALANCE':
        return {
            ...state,
            balance: action.payload,
        };
        case 'ADD_TO_CACHE': {
                const {url, img} = action.payload;
                const newCache = new Map(state.imageCache);
                newCache.set(url, img);
                return { ...state, imageCache: newCache};
        }
        case 'REMOVE_FROM_CACHE': {
            const updatedCache = new Map(state.imageCache);
            updatedCache.delete(action.payload);
            return { ...state, imageCache: updatedCache };
        }
        case 'CLEAR_CACHE':
            return { ...state, imageCache: new Map() };

        case 'SET_DB_ERROR':
            return {
                ...state,
                dbError: action.payload
            }
        case 'ADD_IMAGES_TO_DB':
            // Here, you might not actually modify the state since the DB operation is asynchronous
            // This case could be used to signal that an operation has started or completed
            return {
                ...state,
            };
        default:
                return state
    }

};

export default AuthReducer;